import { Injectable } from '@angular/core';
import { IntroductionStep } from '../../models/steps/introduction-step';
import { StepDescription } from '../../models/intefaces/step-description';
import { TranslationsService } from '../translations/translations.service';
import { Step } from '../../models/intefaces/step';
import { IntroductionStepContent } from '../../models/intefaces/translations-response';

const StepDescriptionKeyName = 'step-descriptions';

@Injectable({
  providedIn: 'root',
})
export class IntroductionStepFactoryService {
  constructor(private readonly translationsService: TranslationsService) {}

  createIntroductionStep(step: Step): IntroductionStep {
    const contentName = step['content-name'] as string;
    return new IntroductionStep(
      step.text,
      step.name,
      this.getDescriptions(contentName)
    );
  }

  private getDescriptions(contentName: string): StepDescription[] {
    return this.getStepsDescription(contentName).map(
      ({ title, text, duration }) => new StepDescription(title, text, duration)
    );
  }

  private getStepsDescription(contentName: string): StepDescription[] {
    return this.translationsService.getContent<IntroductionStepContent>(
      contentName
    )[StepDescriptionKeyName];
  }
}
